import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { faUsersLine } from "@fortawesome/free-solid-svg-icons";
import { faHandshake } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import BASE_URL from "../../../baseUrl";

const whyusblock = [
  {
    id: 1,
    icon: faHandHoldingDollar,
    text: "Price is below Market value",
    title: "Low Price ",
  },
  {
    id: 2,
    icon: faHandshake,
    text: "Specialize in Distress property -  Our property either NPL, Bank own, or foreclosure",
    title: "Specialization ",
  },
  {
    id: 3,
    icon: faUsersLine,
    text: "Professional team of staff since 2003",
    title: "Professinal Team",
  },
  {
    id: 4,
    icon: faPeopleGroup,
    text: "More than 5000 real estate agent world-wide",
    title: "Big Network",
  },
  {
    id: 5,
    icon: faHandshake,
    title: "Fast Loans",
    text: "Get loan loans approved and close deal faster",
  },
];

const Whyus = () => {
  const { t } = useTranslation();

  const [data, setData] = useState('')
  const featchData = () => {
    axios
      .get(`${BASE_URL}/moto/get-motos`)
      .then((res) => {
        setData(res.data.result)
      });
  }
  useEffect(() => {
    featchData()
  }, []);
  
  return (
    <div className="section section-padding infographics-3">
      <div className="container">
        <div className="section-title-wrap section-header">
        <h5 className="custom-primary">{t("ourMotto")}</h5>
      <h2 className="title">{t("chooseToWorkWithUs")}</h2>
        </div>
        <div className="row">
          {Array.isArray(data) && data.map((item, i) => (
            <div key={i} className="col-lg-4">
              <div className="acr-infographic-item">
                <div className="flex">
                  <img alt="Icon" className="myImageIcon" src={item.image} />
                  <div className="acr-infographic-item-body">
                    <h5>{t(item.title)}</h5>
                    <p>{t(item.description)}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Whyus;